import { createContext, ReactNode, useRef, useState } from "react";
import { SignaturePadRef } from "../Add Risk Assessment/SignaturePadComponent";

export const PermitSignatureContext = createContext<any>(null);



export const PermitSignatureProvider = ({ children }: { children: ReactNode }) => {
  const [permitApprovalRefs, setPermitApprovalRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [permitClosureRefs, setPermitClosureRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);

  // In your context
const [permitSignatureDataUrl, setPermitSignatureDataUrl] = useState<any>({
    permitApproval: [],
    permitClosure: []
});

  return (
    <PermitSignatureContext.Provider value={{ permitApprovalRefs, setPermitApprovalRefs, permitClosureRefs, setPermitClosureRefs, permitSignatureDataUrl, setPermitSignatureDataUrl }}>
      {children}
    </PermitSignatureContext.Provider>
  );
};